import React from "react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

export default function Timeline() {
  const { t } = useLang();
  return (
    <section id="legacy" className="section-pad relative bg-ink-surface">
      <div className="container-luxe">
        <Reveal className="mb-16 text-center">
          <p className="overline mb-4">{t.timeline.overline}</p>
          <h2 className="font-serif text-3xl font-light text-white sm:text-4xl lg:text-5xl">{t.timeline.title}</h2>
        </Reveal>

        <div className="relative mx-auto max-w-5xl">
          {/* Center spine (left on mobile, centered on desktop) */}
          <div className="absolute left-[7px] top-2 bottom-2 w-px -translate-x-1/2 bg-gradient-to-b from-gold/60 via-gold/30 to-gold/5 md:left-1/2" />

          <div className="space-y-10 md:space-y-14">
            {t.timeline.events.map((e, i) => {
              const left = i % 2 === 0;
              return (
                <Reveal key={i}>
                  <div data-testid={`timeline-event-${i}`} className="group relative">
                    {/* Node on the spine */}
                    <span className="absolute left-[7px] top-2 z-10 flex h-4 w-4 -translate-x-1/2 items-center justify-center md:left-1/2">
                      <span className="h-3.5 w-3.5 rotate-45 border border-gold bg-ink transition-colors duration-300 group-hover:bg-gold" />
                    </span>

                    {/* Content card — alternating side on desktop */}
                    <div
                      className={`pl-12 md:w-1/2 md:pl-0 ${
                        left ? "md:pr-14 md:text-right" : "md:ml-auto md:pl-14 md:text-left"
                      }`}
                    >
                      <div
                        className={`flex flex-col gap-x-4 gap-y-1 sm:items-baseline ${
                          left ? "sm:flex-row md:flex-row-reverse md:justify-start" : "sm:flex-row"
                        }`}
                      >
                        <span className="font-serif text-2xl leading-none text-gold-gradient sm:text-3xl">{e.y}</span>
                        <h3 className="font-serif text-lg text-white sm:text-xl">{e.name}</h3>
                      </div>
                      <p className={`mt-3 text-sm leading-relaxed text-white/55 md:text-base ${left ? "md:ml-auto" : ""}`}>
                        {e.t}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
